module.exports = __webpack_public_path__ + "img/upW.96f687cb.png";